import React from 'react';
import { ZdsRangeSlider } from '@zig-design-system/ui-components-react';
import { renderToString } from 'react-dom/server';
import Translation from '../../../../Shared/components/Translation';
const PriceFilter = ({ filter, handleFilterChange, activeFilters }) => {
    const minPriceOption = filter.options.find((option) => option.filterQuery.endsWith('_min'));
    const maxPriceOption = filter.options.find((option) => option.filterQuery.endsWith('_max'));
    const getValue = () => {
        var _a, _b;
        const minValue = ((_a = activeFilters.userFilters) === null || _a === void 0 ? void 0 : _a[minPriceOption.filterQuery]) || Number(minPriceOption.filterValue);
        const maxValue = ((_b = activeFilters.userFilters) === null || _b === void 0 ? void 0 : _b[maxPriceOption.filterQuery]) || Number(maxPriceOption.filterValue);
        return `[${minValue}, ${maxValue}]`;
    };
    return (React.createElement("div", { id: filter.field },
        React.createElement(ZdsRangeSlider, { step: filter.config['step'], label: renderToString(React.createElement(Translation, { item: filter.label, asString: true })), min: Number(minPriceOption.filterValue), max: Number(maxPriceOption.filterValue), "multiple-knobs": true, onZdsChange: handleFilterChange, value: getValue() },
            React.createElement("span", { slot: "content-start-1" }, "\u20AC"),
            React.createElement("span", { slot: "content-start-2" }, "\u20AC"))));
};
export default PriceFilter;
